<template>
  <app-logged id="VinculoUpdate">
    <v-flex xs12>
      <v-form>
        <app-widget
          class-widget="sm8 offset-sm2 xs12"
        >
          <div slot="widget-content">
            <AppFormHeader
              title="Atualizar parâmetros do vínculo"
              :subtitle="`${vinculo.cliente_nome} | ${vinculo.industria_nome}`"
              icon="supervised_user_circle"
            />
            <v-tabs vertical>
              <v-tab>
                <v-icon
                  left
                  small
                  :color="getBooleanColor(cadastramento.completo)"
                >
                  {{ getBooleanIcon(cadastramento.completo) }}
                </v-icon>
                Cadastramento
              </v-tab>
              <v-tab>
                <v-icon
                  left
                  small
                  :color="getBooleanColor(primeira.completo)"
                >
                  {{ getBooleanIcon(primeira.completo) }}
                </v-icon>
                Primeira fase
              </v-tab>
              <v-tab>
                <v-icon
                  left
                  small
                  :color="getBooleanColor(segunda.completo)"
                >
                  {{ getBooleanIcon(segunda.completo) }}
                </v-icon>
                Segunda fase
              </v-tab>
              <v-tab>
                <v-icon
                  left
                  small
                  :color="getBooleanColor(terceira.completo)"
                >
                  {{ getBooleanIcon(terceira.completo) }}
                </v-icon>
                Terceira fase
              </v-tab>
              <!-- CADASTRAMENTO -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-checkbox
                      class="mt-0"
                      hide-details
                      v-model="cadastramento.termo_participacao"
                      label="Termo Acordo de Participação"
                    />
                    <v-checkbox
                      hide-details
                      v-model="cadastramento.termo_desistencia"
                      label="Termo Desistência"
                    />
                    <v-checkbox
                      hide-details
                      v-model="cadastramento.declaracao_titular"
                      label="Declaração do Titular"
                    />
                    <v-checkbox
                      hide-details
                      v-model="cadastramento.recebimento_caderno"
                      label="Recebimento Carderno"
                    />
                    <v-card-actions
                      slot="widget-actions"
                      class="mt-4"
                    >
                      <app-button
                        @click.native="updateCadastramento"
                        block
                        outlined
                      >
                        salvar
                      </app-button>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- PRIMEIRA FASE -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-checkbox
                      class="mt-0"
                      hide-details
                      v-model="primeira.termo_entrega_produtos"
                      label="Termo de Entrega dos Produtos"
                    />
                    <v-checkbox
                      hide-details
                      v-model="primeira.analise_solo"
                      label="Análise Solo"
                    />
                    <v-checkbox
                      hide-details
                      v-model="primeira.planejamento_forrageiro"
                      label="Planejamento Forrageiro"
                    />
                    <v-checkbox
                      hide-details
                      v-model="primeira.amostragem_solo"
                      label="Certificado - Amostragem do Solo"
                    />
                    <v-checkbox
                      hide-details
                      v-model="primeira.aplicacao_injetaveis"
                      label="Certificado - Aplicação de Injetáveis"
                    />
                    <v-card-actions
                      slot="widget-actions"
                      class="mt-4"
                    >
                      <app-button
                        @click.native="updatePrimeiraFase"
                        block
                        outlined
                      >
                        salvar
                      </app-button>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- SEGUNDA FASE -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-checkbox
                      class="mt-0"
                      hide-details
                      v-model="segunda.termo_entrega_produtos"
                      label="Termo de Entrega dos Produtos"
                    />
                    <v-checkbox
                      hide-details
                      v-model="segunda.analise_solo"
                      label="Análise Solo"
                    />
                    <v-checkbox
                      hide-details
                      v-model="segunda.planejamento_forrageiro"
                      label="Planejamento Forrageiro"
                    />
                    <v-checkbox
                      hide-details
                      v-model="segunda.boas_praticas_agropecuarias"
                      label="Manual de Boas Práticas Agropecuárias"
                    />
                    <v-checkbox
                      hide-details
                      v-model="segunda.caderno_fluxo_caixa"
                      label="Caderno Fluxo de Caixa"
                    />
                    <v-card-actions
                      slot="widget-actions"
                      class="mt-4"
                    >
                      <app-button
                        @click.native="updateSegundaFase"
                        block
                        outlined
                      >
                        salvar
                      </app-button>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- TERCEIRA FASE -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-checkbox
                      class="mt-0"
                      hide-details
                      v-model="terceira.termo_entrega_produtos"
                      label="Termo de entrega de produtos"
                    />
                    <v-checkbox
                      hide-details
                      v-model="terceira.analise_solo"
                      label="Análise Solo"
                    />
                    <v-checkbox
                      hide-details
                      v-model="terceira.planejamento_forrageiro"
                      label="Planejamento Forrageiro"
                    />
                    <v-card-actions
                      slot="widget-actions"
                      class="mt-4"
                    >
                      <app-button
                        @click.native="updateTerceiraFase"
                        block
                        outlined
                      >
                        salvar
                      </app-button>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </app-widget>
      </v-form>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
export default {
  name: 'VinculoUpdate',
  components: {
    AppWidget,
    AppLogged,
    AppFormHeader,
    AppButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['vinculo']),
    cadastramento: {
      get () {
        return this.vinculo.cadastramento
      },
      set (val) {
        this.vinculo.cadastramento = val
      }
    },
    primeira: {
      get () {
        return this.vinculo.primeiraFase
      },
      set (val) {
        this.vinculo.primeiraFase = val
      }
    },
    segunda: {
      get () {
        return this.vinculo.segundaFase
      },
      set (val) {
        this.vinculo.segundaFase = val
      }
    },
    terceira: {
      get () {
        return this.vinculo.terceiraFase
      },
      set (val) {
        this.vinculo.terceiraFase = val
      }
    }
  },
  methods: {
    ...mapActions(['putSaveVinculo', 'putSaveCadastramento', 'putSavePrimeiraFase', 'putSaveSegundaFase', 'putSaveTerceiraFase']),
    getBooleanIcon (value) {
      return value ? 'check_circle' : 'remove_circle'
    },
    getBooleanColor (value) {
      return value ? 'success' : 'error'
    },
    async updateCadastramento () {
      await this.putSaveCadastramento()
      return this.$router.go(0)
    },
    async updatePrimeiraFase () {
      await this.putSavePrimeiraFase()
      return this.$router.go(0)
    },
    async updateSegundaFase () {
      await this.putSaveSegundaFase()
      return this.$router.go(0)
    },
    async updateTerceiraFase () {
      await this.putSaveTerceiraFase()
      return this.$router.go(0)
    }
  }
}
</script>
